const initialState = {
  keywordLabels: {
    daycare: "School",
    daycareProfessional: "Teacher",
    section: "Class",
    group: "Section",
    session: "Session",
    child: "Child",
    pluralChild: "Children",
    activity: "Activity",
    pluralActivity: "Activities",
    childAgeIn: "Months",
    operationalDays: [
      "Monday",
      "Tuesday",
      "Wednesday",
      "Thursday",
      "Friday"
    ],
    welcomeMessage: [
      "Dear Parents,",
      "Greetings from Sparkle! We are glad that you are choosing Sparkle for your child.",
      "Kindly fill the details in this short form to enroll your child at Sparkle. This form will take less than 60 seconds to enter the minimum required details to start the process.",
      "Thank you.",
      "Team Sparkle."
    ],
    orgName: "Sparkle"
  }
};

const formReducer = (state = initialState, action) => {
  switch (action.type) {
    case "UPDATE_FORM_DATA":
      return {
        ...state,
        formData: { ...state.formData, ...action.payload },
      };
    case "SUBMIT_FORM_DATA":
      return {
        ...state,
        formData: {},
      };
    case "SCHOOL_DETAILS":
      return {
        ...state,
        schoolDetails: { ...state.schoolDetails, ...action.payload },
      };
    case "UPDATE_KEYWORD_LABELS":
      return {
        ...state,
        keywordLabels: { ...state.keywordLabels, ...action.payload },
      };
    default:
      return state;
  }
};

export default formReducer;
